import React from 'react';
export function ProblemSection() {
  const problems = ['Dudás antes de actuar aunque sepas lo que tenés que hacer', 'Te bloqueás cuando hay presión o múltiples demandas', 'Sentís que te falta claridad mental en momentos críticos', 'Pensás demasiado y eso te hace perder tiempo', 'Terminás el turno agotada mentalmente'];
  return <section className="section-gradient text-white py-5 px-5" data-id="element-241">
      <div className="max-w-xl mx-auto relative z-10" data-id="element-242">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-3 leading-tight" data-id="element-243">
          😩 ¿Te está pasando esto…?
        </h2>
        <p className="text-center text-brand-yellow font-bold text-lg mb-8" data-id="element-244">
          Te va a sonar familiar:
        </p>

        <div className="space-y-3 mb-10" data-id="element-245">
          {problems.map((problem, idx) => <div key={idx} className="bg-gray-900 border border-gray-800 p-4 rounded-xl flex items-start gap-3" data-id="element-246">
              <span className="text-red-500 text-lg flex-shrink-0" data-id="element-247">❌</span>
              <p className="text-sm text-gray-300 font-medium leading-relaxed" data-id="element-248">
                {problem}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-249">
          <h3 className="text-xl md:text-2xl font-bold text-brand-yellow mb-6" data-id="element-250">
            ¿Cuánto tiempo más vas a seguir trabajando así?
          </h3>
        </div>
      </div>
    </section>;
}